import React, { useState, useEffect} from 'react';
import api from '../conexao.js';
import DOMPurify from 'dompurify';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import htmlToPdfMake from 'html-to-pdfmake';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState,  convertToRaw, ContentState } from 'draft-js';

import {Modal, Form, Button, Spinner} from 'react-bootstrap';
import logOut from '../logOut';
import PrintReports from './print.js';
import ReceituarioControlado from './controlado.js';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons"
import {faClone,faPaste} from "@fortawesome/free-solid-svg-icons"
import { sendFile } from '../whatsApp/sendZap.js';
import './editorTexto.css';
import {removeBlankLines,removeFontAttributes,convertListsToPdfMake}  from './draftToPdfMake';
import toast from 'react-hot-toast';
import { useUnsavedChangesContext } from './UnsavedChangesGuard';

export default function Receituario(props){

const [html, setHTML] = useState('');
const [contentBlock] = useState(htmlToDraft(html));
const [contentState] = useState(ContentState.createFromBlockArray(contentBlock.contentBlocks));
const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState));   

const [textoBanco, setTextoBanco] = useState();
const [data, setData] = useState(new Date())

const [receituario, setReceituario] = useState([]);
const [codReceituario, setCodReceituario] = useState();
const [medicamento, setMedicamento] = useState([]);
const [codMedicamento, setCodMedicamento] = useState();
const [disableData, setDisableData] = useState(false);
const [mostraModal, setMostraModal] = useState(false);
const [mostraModalRel, setMostraModalRel] = useState(false);
const [modalGravado, setModalGravado] = useState(false);
const [modalMSG, setModalMSG] = useState(false);
const [modalImprime, setModalImprime] = useState(false);
const [modalEnviar, setModalEnvia] = useState(false);
const [botaoEnv, setBotaoEnv] = useState(false);
const [copiaReceituario, setCopiaReceituario] = useState();
const [modalPreview, setModalPreview] = useState(false);
const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);


const [auxStatus, setAuxStatus] = useState(false)

// const [txt, setTxt] = useState();
const [MSG, setMSG] = useState();
const [medico, setMedico] = useState();
const [medicoData, setMedicoData] = useState({});
const [dataBR, setDataBR] = useState();
const [loading, setLoading] = useState(true)
const [send, setSend] = useState(false)
// var urlPreSign;
const pdfMake = require('pdfmake/build/pdfmake');
const pdfFonts = require('pdfmake/build/vfs_fonts');
const [edicao, setEdicao] = useState(false); // botao gravar
const [btnCancelar, setBtnCancelar] = useState(false);

// Integração com sistema de proteção de mudanças não salvas
const { registerUnsavedTab, unregisterUnsavedTab } = useUnsavedChangesContext();
const tabKey = props.tabKey || 'receituario';

// Monitora mudanças no estado de edição
useEffect(() => {
    if (!edicao) {
        // Há mudanças não salvas
        registerUnsavedTab(tabKey);
    } else {
        // Não há mudanças não salvas
        unregisterUnsavedTab(tabKey);
    }
    
    // Cleanup quando componente desmonta
    return () => {
        unregisterUnsavedTab(tabKey);
    };
}, [edicao, registerUnsavedTab, unregisterUnsavedTab, tabKey]);

const toolBarValues = {
    options: ["inline", "fontSize", "colorPicker", "textAlign", "list"],
    inline: {
      inDropdown: false,
      options: ["bold", "italic", "underline", "strikethrough"]
    },
    list: {
      inDropdown: false,
      options: ["unordered", "ordered"]
    }
};


function onEditorStateChange(editorState) {
    setEditorState(editorState)
    setTextoBanco(draftToHtml(convertToRaw(editorState.getCurrentContent())));
};

const sanitizeContent = (content) => {
    return DOMPurify.sanitize(content, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'ol', 'ul', 'li', 'span', 'div'],
        ALLOWED_ATTR: ['style'],
        ALLOW_DATA_ATTR: false
    });
};

function transformaData(d){                     // converte data = new Date() para DD/MM/YYYY
    var date = new Date(d)                      // converte a data ISO DateTimeStamp(como vem do banco) para DD/MM/YYYY
    date.setHours(0,0,0,0)                      // zera a hora 00:00:00
    return(date.getDate()+'/' + (date.getMonth()+1) + '/'+date.getFullYear())      
}

function transformaDataBanco(d){                     // converte data = new Date() para DD/MM/YYYY
    var date = new Date(d)                      // converte a data ISO DateTimeStamp(como vem do banco) para DD/MM/YYYY
    date.setHours(0,0,0,0)                      // zera a hora 00:00:00
    return(date.getFullYear()+'/' + (date.getMonth()+1) + '/'+date.getDate())   
}

useEffect(() => {
        
    async function buscaReceituario() {
        await api.get('/receituario',{
        params: {           
            idPac: props.idPac
        }                
    }).then ( result => {
        if (result.data[0]) {
        result.data.sort((COD1, COD2) => { // ORDENA LISTA DO COMBO POR CODIGO | ORDEM DECRESCENTE
            COD1 = COD1.CODIGO;
            COD2 = COD2.CODIGO;

            if (COD1 > COD2) {
                return -1;
            }
            if (COD1 < COD2) {
                return 1;
            } return 0;
        })

            result.data.map( r => {
                r.DATA = transformaData(r.DATA) 

            })
            
            setReceituario(result.data);
            if (result.data[0]) {
                setCodReceituario(result.data[0].CODIGO);   
                 setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft( result.data[0].TEXTOCONVERTIDO))));
                setBtnCancelar(true)
                setDataBR(result.data[0].DATA)
            } else {
                setBtnCancelar(true) 
            }   
            }else { 
                setBtnCancelar(true)
             }
    }).catch(
            (error) => {
            setMSG(logOut(error))
            setModalMSG(true)
            }
         )
    
    // .catch((error) => logOut(error))
}

    async function buscaMedicamento(){
        await api.get('/medicamento',{params:{
            nome: '%'
        }}).then (
            result => {
                setMedicamento(result.data)
                if (result.data[0]) {
                    setCodMedicamento(result.data[0].CODIGO) 
                    } 
            }, setLoading(false)
    ).catch(
        (error) => {
            setMSG(logOut(error))
            setModalMSG(true)
            }
        )
    }
    
    async function buscaDadosMedico(){
        await api.get('/medico/', {params: {
            codigo: parseInt(props.idMed)
        }}).then((result) => {
            setMedicoData(result.data);
        }).catch((error) => {
            setMSG(logOut(error))
            setModalMSG(true)
        })
    }
    // console.log(props.usuarioZap)
    buscaReceituario();
    buscaMedicamento();
    buscaDadosMedico();
    setEdicao(true)
    setBtnCancelar(true)

},[props.idPac]);

 async function handleNovaReceita(){
           // aux para saber se é um novo receituario se TRUE é novo RECIETA
    data.setHours(0,0,0,0) 
    
    setEdicao(false) // destrava o botão GRAVAR

  
    setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(''))));
    
    
  

    setDisableData(true) //desativa o campo de data para não poder trocar
    setBtnCancelar(false)
  

//     await api.post('/receituario', {
//             COD_PACIENTE: parseInt(props.idPac),
//             DATA: transformaDataBanco(data),
//             TEXTO: '<p></p>'
//  }).catch(
                
//     (error) => {
//         setMSG(logOut(error))
//         setModalMSG(true)
//     }
    
//     )
//     await api.get('/receituario',{
//             params: {           
//                 idPac: props.idPac
//             }                
//     }).then ( result => {

//                     result.data.sort((COD1, COD2) => {// ORDENA LISTA DO COMBO POR CODIGO.
//                         COD1 = COD1.CODIGO;
//                         COD2 = COD2.CODIGO;

//                         if (COD1 > COD2) {
//                             return -1;
//                         }
//                         if (COD1 < COD2) {
//                             return 1;
//                         } return 0;
//                     })

//                     result.data.map( r => {
//                     r.DATA = transformaData(r.DATA)  

//             }
//     )

//     setReceituario(result.data);
//     setCodReceituario(result.data[0].CODIGO);
//     setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(''))));
//     setBtnExcluir(false)
// }).catch(           
//     (error) => {
//         setMSG(logOut(error))
//         setModalMSG(true)
//     }
//     )
// setAuxStatus(true)
// setBtnExcluir(false) // ATIVA O OBOTAO DE EXCLUIR
}

async function handleGravar(codRec){
        data.setHours(0,0,0,0) 
        setDataBR(transformaData(data))
        await api.post('/receituario/', {
            COD_PACIENTE: parseInt(props.idPac),
            DATA: transformaDataBanco(data),
            TEXTO: sanitizeContent(textoBanco)
        }).then(  () =>  {setModalGravado(true)})
        .catch(
            (error) => {
                setMSG(logOut(error))
                setModalMSG(true)
            }
            )


    async function buscaReceituario() {
        await api.get('/receituario',{
        params: {           
            idPac: props.idPac
        }                
    }).then ( result => {

        result.data.sort((COD1, COD2) => {// ORDENA LISTA DO COMBO POR CODIGO.
            COD1 = COD1.CODIGO;
            COD2 = COD2.CODIGO;

            if (COD1 > COD2) {
                return -1;
            }
            if (COD1 < COD2) {
                return 1;
            } return 0;
        })           

            result.data.map( r => {
                r.DATA = transformaData(r.DATA)    
            })
          
            setReceituario(result.data);
            setCodReceituario(result.data[0].CODIGO);     
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(result.data[0].TEXTOCONVERTIDO))));

    })
    .catch( 
        (error) => {
            setMSG(logOut(error))
            setModalMSG(true)
        }
        )}
    buscaReceituario();
    setDisableData(false) //Ativa o campo data para alterar, depois de gravado
    setBtnCancelar(true);
    setEdicao(true)
}

function handleCodReceituario(e) {
     setCodReceituario(e)
      
        
     receituario.map( receit => {
         if (parseInt(receit.CODIGO) === parseInt(e)) {
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(receit.TEXTOCONVERTIDO))));   
        
             setDataBR(receit.DATA)
             
            
        }
         
        })
        
}

function handleAdicionaMedicamento(){
    if ( typeof codMedicamento === 'undefined') {
        // alert('Selecione o Medicamento')
        setMSG('Selecione o Medicamento');
        setModalMSG(true);
    } else {

    medicamento.map( medic => {
        if (parseInt(medic.CODIGO) === parseInt(codMedicamento)) {
            onEditorStateChange(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(
                draftToHtml(convertToRaw(editorState.getCurrentContent())) + '<p>' + medic.NOME + '</p><p>' + medic.DOSE + '</p>'))));                         // VAI SER USADO PARA ADD TEXTO
        } 
    })
}

}

function handleMostraModal(m){
    setMostraModal(m)
}

async function handleExcluirReceita(cod){  //cancela
//    setMSG('Cancelado!')
//    setModalMSG(true)
   setMostraModal(false)
   setEdicao(true)
   setBtnCancelar(true)
   setDisableData(false)
   setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(''))));
   



//     await api.delete('/receituario/'+ parseInt(cod))
//     .then( () => {setMSG('Excluido')
//             setModalMSG(true)}

//     )
//     .catch( 
//             (error) => {
//             setMSG(logOut(error))
//             setModalMSG(true)
//             }
//         )
    
//     setMostraModal(false);

     
    await api.get('/receituario',{
        params: {           
            idPac: props.idPac
        }                
        }).then (  
            result => {
            if (result.data[0]) {
                result.data.sort((COD1, COD2) => {// ORDENA LISTA DO COMBO POR CODIGO.
                    COD1 = COD1.CODIGO;
                    COD2 = COD2.CODIGO;
        
                    if (COD1 > COD2) {
                        return -1;
                    }
                    if (COD1 < COD2) {
                        return 1;
                    } return 0;
                })  
                
                result.data.map( r => {
                    r.DATA = transformaData(r.DATA)    
                })
                setDataBR(result.data[0].DATA)
                setReceituario(result.data);
                setCodReceituario(result.data[0].CODIGO);
                setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(result.data[0].TEXTOCONVERTIDO))));

            } else { //SE NAO TIVER RECEITUARIO APÓS APAGAR
            setReceituario(result.data)
            setBtnCancelar(true)
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(''))));
        }
    })    .catch( 
        (error) => {
            setMSG(logOut(error))
            setModalMSG(true)
        }
        )
}

function handleMostrarModalRel(m){
    setMostraModalRel(m);
}

// function setUrlPreSign(url){
//     urlPreSign = url;
// }



async function chamaPDF(send){
    
    // let nomeLinkR = 'https://imgmedsolutions.s3.sa-east-1.amazonaws.com/'+ 'R' + props.paciente.replaceAll(' ','+').toLowerCase() + '.pdf';
    var namePDF = 'R'+props.paciente.toLowerCase();
    // let auxTexto = convertToRaw(editorState.getCurrentContent()).blocks
    // let texto =  auxTexto.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
    var docDefinitions; //ARQUIVO COM AS DEFINICOES DO ARQUIVO PDF
    var bufferPDF;      // ARQUIVO PDF GERADL PELO MAKE AQUI NO RECEITUARIO
    var assinatura;

    let rawContentState = convertToRaw(editorState.getCurrentContent()); 

    let html = draftToHtml(rawContentState); 
    html = convertListsToPdfMake(html);
    var texto = htmlToPdfMake(html);

    // console.log(html)
    // console.log(texto)

    // joga o lineHeight dentro do PDF em cada paragrafo.
    texto.forEach(element => { if (element.nodeName === 'P') { element.style = element.style || []; element.style.push({ lineHeight: 1.4 }); } });
    //remove a fonte
   
    
    // remove as linhas em branco abaixo
    texto = await removeBlankLines(texto);
    //remove font e fontSize
    texto = removeFontAttributes(texto)

    // console.log(texto)

    // Função para verificar se assinatura está vazia
    const isSignatureEmpty = (signature) => {
        if (!signature) return true;
        const emptyCanvas = document.createElement('canvas');
        emptyCanvas.width = 320;
        emptyCanvas.height = 200;
        const emptyDataURL = emptyCanvas.toDataURL();
        return signature === emptyDataURL || signature.length < 1000;
    };

    await api.get('/medico/', {params: {
        codigo:parseInt(props.idMed)
    }} ).then ( (result) => { 
        if (result.data.ASSINATURA && !isSignatureEmpty(Buffer.from(result.data.ASSINATURA).toString())) {
            assinatura = Buffer.from(result.data.ASSINATURA).toString() // PEGA A BASE64 NO BANCO E TRANSFORMA EM ARQUIVO
        } 
    }  ).catch((error) => {setMSG(logOut(error))
                          setModalMSG(true)})
    

   function pdf(){                     // CHAMA O ARQUIVO QUE CRIA AS DEFINICOES DO PDF E DEPOIS CRIA ELE AQUI
        return new Promise((res,rej)=>{
            docDefinitions = PrintReports(texto, props.nomeMed, props.paciente, props.titulo, dataBR,props.crmMed,medicoData.CABECALHO,medicoData.RODAPE,assinatura)  
            res()
        })
    }

    function geraBase64(){
        return new Promise((res,rej)=>{
            if (send) { pdfMake.createPdf(docDefinitions).getBuffer((buffer) => { // CRIA UM BUFFER E DEPOIS TRANSFORMA EM BASE64
                bufferPDF = buffer.toString('base64')                           // QUE PODE SER ENVIADO PELA API MENUIA WHATSAPP
                    })} else { pdfMake.createPdf(docDefinitions).open();}       // erro URLBrowser é pq falta cadastrar assinatura
            res()
        })
    }

    function enviaZap(){
        return new Promise((res,rej)=>{
            setTimeout(()=>                 // SETTIMEOUT PARA ESPERAR A FUNCAO DE CIMA TRABALHAR
            {
                if (send) { sendFile(props.celular,'Receituário',props.usuarioZap,namePDF,bufferPDF)} // FUNCAO QUE ENVIAR O BASE64 PRO ZAP
                setBotaoEnv(false)
                res()
            },5000)
        })
    }
    // CHAMA AS PROMISES, SÓ CONSEGUI ORGANIZAR QUEM EXECUTA PRIMEIRO COM PROMISES E TIMEOUT
    pdf().then(geraBase64().then(enviaZap()))
    setModalImprime(false);
    
 
} 

async function chamaPDFContolado(send){
 //   let nomeLinkRC = 'https://imgmedsolutions.s3.sa-east-1.amazonaws.com/'+ 'RC' + props.paciente.replaceAll(' ','+').toLowerCase() + '.pdf';
    var namePDF = 'RC'+props.paciente.toLowerCase();
    let auxTexto    = convertToRaw(editorState.getCurrentContent()).blocks
    let texto       = auxTexto.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
    var docDefControlado; //ARQUIVO COM AS DEFINICOES DO ARQUIVO PDF
    var bufferPDFControlado;      // ARQUIVO PDF GERADL PELO MAKE AQUI NO RECEITUARIO
    var ende;
    var assinatura;


    await api.get('/medico/', {params: {
                    codigo:parseInt(props.idMed)
                }} ).then ( (result) => {
                    ende = result.data.ENDERECO + ',' + result.data.BAIRRO + ' - ' + result.data.CIDADE +' - '+ result.data.TEL
                    if (result.data.ASSINATURA) {
                        assinatura = Buffer.from(result.data.ASSINATURA).toString()
                    }
                },
                    // console.log(ende)
                    
                ).catch(
                    (error) => {
                        setMSG(logOut(error))
                        setModalMSG(true)})
    
    function pdf(){
        return new Promise((res,rej)=>{
            docDefControlado = ReceituarioControlado(ende,texto, props.nomeMed, props.paciente, props.titulo,dataBR,props.crmMed,medicoData.CABECALHO,medicoData.RODAPE,assinatura)
            // console.log(docDefControlado)
            if (send) { pdfMake.createPdf(docDefControlado).getBuffer((buffer) => {
                bufferPDFControlado = buffer.toString('base64')
            })} else {pdfMake.createPdf(docDefControlado).download('ReceituarioControlado ' + props.paciente + '.pdf')}
            res()
        });
    }

    function enviaZap(){
        return new Promise((res,rej)=>{
            setTimeout(()=>                 // SETTIMEOUT PARA ESPERAR A FUNCAO DE CIMA TRABALHAR
            {
                if (send) { sendFile(props.celular,'Receituário Controlado',props.usuarioZap,namePDF,bufferPDFControlado)} // FUNCAO QUE ENVIAR O BASE64 PRO ZAP
                setBotaoEnv(false)
                res()
            },5000)
        })
    }
    // CHAMA AS PROMISES, SÓ CONSEGUI ORGANIZAR QUEM EXECUTA PRIMEIRO COM PROMISES E TIMEOUT
    pdf().then(enviaZap)
    // setModalEnvia(false)
    setModalImprime(false);


}


function colaReceituario(){

        if (copiaReceituario) {
            setEditorState(copiaReceituario);
            setTextoBanco(draftToHtml(convertToRaw(copiaReceituario.getCurrentContent())));
        } else ( 
            toast.error('Nenhum Receituário Copiado!', { style:{width:'300px', height:'70px',backgroundColor: '#c4defb',
                 color: 'black',
                 fontSize: '18px'}, duration: 3000})
            )
}

async function previewPDF(tipo){
    var docDefinitions;
    var assinatura;
    var texto;
    var ende;

    if (tipo === 'comum') {
        let rawContentState = convertToRaw(editorState.getCurrentContent()); 
        let html = draftToHtml(rawContentState); 
        html = convertListsToPdfMake(html);
        texto = htmlToPdfMake(html);
        texto.forEach(element => { if (element.nodeName === 'P') { element.style = element.style || []; element.style.push({ lineHeight: 1.4 }); } });
        texto = await removeBlankLines(texto);
        texto = removeFontAttributes(texto);

        // Função para verificar se assinatura está vazia
        const isSignatureEmpty = (signature) => {
            if (!signature) return true;
            const emptyCanvas = document.createElement('canvas');
            emptyCanvas.width = 320;
            emptyCanvas.height = 200;
            const emptyDataURL = emptyCanvas.toDataURL();
            return signature === emptyDataURL || signature.length < 1000;
        };

        await api.get('/medico/', {params: {codigo:parseInt(props.idMed)}} ).then ( (result) => { 
            if (result.data.ASSINATURA && !isSignatureEmpty(Buffer.from(result.data.ASSINATURA).toString())) {
                assinatura = Buffer.from(result.data.ASSINATURA).toString()
            } 
        }).catch((error) => {setMSG(logOut(error)); setModalMSG(true)})

        docDefinitions = PrintReports(texto, props.nomeMed, props.paciente, props.titulo, transformaData(data),props.crmMed,medicoData.CABECALHO,medicoData.RODAPE,assinatura);
    } else {
        let auxTexto = convertToRaw(editorState.getCurrentContent()).blocks
        texto = auxTexto.map(block => (!block.text.trim() && '\n') || block.text).join('\n');

        await api.get('/medico/', {params: {codigo:parseInt(props.idMed)}} ).then ( (result) => {
            ende = result.data.ENDERECO + ',' + result.data.BAIRRO + ' - ' + result.data.CIDADE +' - '+ result.data.TEL
            if (result.data.ASSINATURA) {
                assinatura = Buffer.from(result.data.ASSINATURA).toString()
            }
        }).catch((error) => {setMSG(logOut(error)); setModalMSG(true)})

        docDefinitions = ReceituarioControlado(ende,texto, props.nomeMed, props.paciente, props.titulo,transformaData(data),props.crmMed,medicoData.CABECALHO,medicoData.RODAPE,assinatura);
    }

    const pdfDocGenerator = pdfMake.createPdf(docDefinitions);
    pdfDocGenerator.getBlob((blob) => {
        const url = URL.createObjectURL(blob);
        setPdfPreviewUrl(url);
    });
    setModalPreview(false);
}


return(
    <div className="container-fluid" >  
        <br />
        <div className=" form-row">
        <div className="form-row">
    <div className="d-flex w-100">
        
        <div className="d-flex align-items-center">
            <Button variant="primary" size="sm" disabled={!edicao} onClick={() => handleNovaReceita()}>Novo</Button> 
            <span className="me-2"> </span>
            <Button variant="danger" size="sm" disabled={btnCancelar} onClick={() => handleMostraModal(true)}>Cancelar</Button> 
            <span className="me-2"> </span>
            <Button variant="info" size="sm" onClick={() => edicao ? setModalImprime(true) : setModalPreview(true)}>{edicao ? 'Imprimir' : 'Visualizar'}</Button>
            <span className="me-2"> </span>
            <Button disabled={props.whatsapp || !edicao} size="sm" variant="success" onClick={()=> {setModalEnvia(true)}} >
                <FontAwesomeIcon icon={faWhatsapp} size='lg' />
            </Button>
        </div>
        
        <span className="ms-auto d-flex align-items-center">
            
            <Button title="Copiar Receituário"  size="sm" variant="warning" onClick={()=> {setCopiaReceituario(editorState)
                 toast.success('Receituário Copiado!', { style:{width:'250px', height:'70px',backgroundColor: '#c4defb',
                 color: 'black',
                 fontSize: '18px'}, duration: 3000})}} >
                <FontAwesomeIcon icon={faClone} size='lg' />
            </Button>
            <span className="ms-2"> </span>
            <Button title="Colar Receituário" size="sm" variant="warning" onClick={()=> {colaReceituario()}} >
                <FontAwesomeIcon icon={faPaste} size='lg' />
            </Button>
        </span>
    </div>
</div>
        <div className='row'>
            <div className="col-md-2">
                Receituários Emitidos:
                {!disableData && <Form.Control  size="sm" as="select" 
                value={codReceituario} 
                onChange={e => handleCodReceituario(e.target.value)} 
                disabled={disableData} >                               
                                    {receituario.map( receit => (
                                        <option key={receit.CODIGO} value={receit.CODIGO}>{DOMPurify.sanitize(receit.DATA)}</option>
                                        ))}
                </Form.Control> }
                {disableData && <Form.Control  size="sm" as="select" 
                value={codReceituario} 
                onChange={e => handleCodReceituario(e.target.value)} 
                disabled={disableData} >                               
                                   
                                        <option >{transformaData(data)}</option>
                                        
                </Form.Control> }
            </div>

            <div className="col-md-2">
                Medicamento:
                <Form.Control  size="sm" as="select" 
                value={codMedicamento} 
                onChange={e => setCodMedicamento(e.target.value)} >                               
                                    {medicamento.map( medic => (
                                        <option key={medic.CODIGO} value={medic.CODIGO}>{DOMPurify.sanitize(medic.NOME)}</option>
                                        ))}
                </Form.Control> 
                
            </div>
            <div className="col-md-2">
                <br />
                 <Button variant="success" disabled={btnCancelar} size="sm" onClick={m => handleAdicionaMedicamento()} >Adicionar a Receita</Button>
            </div>
        </div>
        </div>
        <div className=" btn-group-vertical col-md-12 ">
            <div className="editor-container" style={{backgroundColor:'white',width:'100%'}}>
                <Editor 
                        editorState={editorState}
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor"
                        onEditorStateChange={onEditorStateChange}
                        placeholder="Digite o Texto"
                        toolbar={toolBarValues}
                        readOnly={edicao}
                        toolbarStyle={{position: 'sticky', top: 0, zIndex: 1000, backgroundColor: 'white'}}
                        editorStyle={{height: '500px', overflow: 'auto'}}
                />
            </div>
        </div>
        <br />
        <div className=" btn-group-vertical col-md-1">
            <Button variant="primary" disabled={edicao} onClick={() => handleGravar(codReceituario)}>Gravar</Button>
        </div>
        <Modal show={mostraModal}>
            <Modal.Header> 
                <h3>Cancelar ?</h3>
            </Modal.Header> 
            <Modal.Footer>
                <Button variant="danger" onClick={() => handleExcluirReceita()}>Sim</Button>
                <Button variant="info" onClick={() => handleMostraModal(false)}>Não</Button>
         </Modal.Footer>
        </Modal>

        <Modal show={modalGravado}>
                <Modal.Header> 
                    <h3>Gravado!</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalGravado(false)}>Ok</Button>
                </Modal.Footer>
            </Modal> 

        <Modal show={mostraModalRel}>
            <Modal.Header> 
                <h3>Que tipo de Receita?</h3>
            </Modal.Header> 

        </Modal>
        <Modal show={modalMSG}>
                <Modal.Header> 
                    <h3>{MSG}</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalMSG(false)}>Ok</Button>
                </Modal.Footer>
            </Modal> 
            <Modal show={modalImprime}>
                <Modal.Header> 
                    <h3>Qual tipo de Receituário?</h3>
                </Modal.Header> 
                <Modal.Footer> 
                    <Button variant="info" onClick={() => chamaPDF(false)}>Comum</Button>
                    <Button variant="info" onClick={() => chamaPDFContolado(false)}>Controlado</Button>
                    <Button variant="danger" onClick={() => setModalImprime(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal> 
            <Modal show={modalEnviar}>
                <Modal.Header> 
                    <h3>Qual tipo de Receituário?</h3>
                </Modal.Header> 
                <Modal.Footer> 
                   {botaoEnv ? <>Enviando...<Spinner /></> : <><Button variant="info" onClick={() => {  chamaPDF(true)
                                                                                         setBotaoEnv(true)
                                                                                         }}>Comum</Button>
                    <Button variant="info" onClick={() => { chamaPDFContolado(true)
                                                             setBotaoEnv(true)}}>Controlado</Button>
                    <Button variant="danger" onClick={() => {  setModalEnvia(false)}}>Fechar</Button></>}
                </Modal.Footer>
            </Modal> 
            <Modal show={loading}>
                <Modal.Body>
                    Aguarde....
                </Modal.Body>
            </Modal>
            <Modal show={modalPreview}>
                <Modal.Header> 
                    <h3>Escolha o tipo para Visualizar</h3>
                </Modal.Header> 
                <Modal.Footer> 
                    <Button variant="info" onClick={() => previewPDF('comum')}>Comum</Button>
                    <Button variant="info" onClick={() => previewPDF('controlado')}>Controlado</Button>
                    <Button variant="danger" onClick={() => setModalPreview(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={pdfPreviewUrl !== null} size="lg" centered onHide={() => {URL.revokeObjectURL(pdfPreviewUrl); setPdfPreviewUrl(null);}}>
                <Modal.Header closeButton> 
                    <h3>Visualização do Receituário</h3>
                </Modal.Header> 
                <Modal.Body>
                    {pdfPreviewUrl && <iframe src={pdfPreviewUrl + '#toolbar=0'} style={{width: '100%', height: '600px', border: 'none'}} title="Preview PDF"></iframe>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => {URL.revokeObjectURL(pdfPreviewUrl); setPdfPreviewUrl(null);}}>Fechar</Button>
                </Modal.Footer>
            </Modal>  
    </div>
)

}

